<style lang="scss" scoped>
.bots-header {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  &__item {
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
  }
}
hr {
  border: 1px solid var(--color-background);
  /*border-top: 1px double darkgray;*/
  border-top: none;
  /*color: #333;*/
  overflow: visible;
  text-align: center;
  height: 0px;
  margin: 10px -20px;
}

.box1 {
  padding-top: 20px;
  padding-bottom: 30px;
  padding-left: 20px;
  padding-right: 20px;
}
.bots-table {
  /*padding: 0px 10px 10px 10px;*/
  border-collapse: collapse;
  width: 100%;
  /*margin-bottom: 20px;*/
}
.bots-table-header {
  border-bottom: 1px solid var(--color-border);
  padding: 10px;
  text-align: left;
  font-size: 12px;
  color: var(--color-text-dark);
}
.bots-table-cell {
  padding: 10px;
  text-align: left;
  font-size: 14px;
}
.tablerow {
  background-color: var(--color-card-dark);
  height: 102px;
  /*cursor: pointer;*/
}
.oddrow {
  background-color: var(--color-card);
}
.table-names {
  font-size: 8px;
  color: var(--color-text-dark);
  font-weight: bold;
}
.table-value-text {
  padding-left: 2px;
}
.table-names-top-padding {
  padding-top: 4px;
}
.action:hover {
  /*color: var(--color-accent-dark);*/
  /*text-decoration: underline;*/
  background: linear-gradient(to bottom left, var(--color-accent-dark), var(--color-accent));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.profitText {
  font-size: 14px;
  text-align: right;
}
.actionButton {
  font-size: 16px;
  /*size: 20px;*/
  cursor: pointer;
  /*padding: 10px;*/
  /*padding-right: 10px;*/
}
.notrades {
  text-align: center;
  color: var(--color-neutral-light);
  font-size: 16px;
}
.status-filter {
  width: 145px;
}
.yellow {
  color: #ffd60c;
}
.bot-hist-info-cell {
  text-align: left;
  font-size: 14px;
}

.filterBox {
  display: grid;
  grid-template-areas: 'acthist new openorders symbol search symbolfilter statusfilter instruction';
  grid-template-columns: minmax(179px, 2fr) 2fr 1fr repeat(4, 2fr) 1fr;
  grid-gap: 15px;
  /*display: flex;*/
  justify-content: space-between;
  align-items: center;
}
@media all and (max-width: 1000px) {
  .filterBox {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      'acthist new symbol instruction'
      'search openorders statusfilter symbolfilter';
  }
  #search {
    margin-left: 10px;
  }
  #new {
    margin-left: 30px;
  }
  #symbolfilter {
    margin-left: 30px;
    justify-self: flex-end;
  }
  #openorders {
    margin-left: 80px;
  }
}
a:hover {
  text-decoration: underline;
}
#symbol {
  grid-area: symbol;
}
#symbolfilter {
  grid-area: symbolfilter;
}
#instruction {
  grid-area: instruction;
  justify-self: flex-end;
}
#new {
  grid-area: new;
}
#search {
  grid-area: search;
}
#statusfilter {
  grid-area: statusfilter;
}
#acthist {
  grid-area: acthist;
}
td {
  /*border: 1px solid var(--color-success-light);*/
}
div {
  /*border: 1px solid var(--color-success-light);*/
}
</style>

<template>
  <div class="box box1">
    <OpenOrdersModal @on-cancel="$store.state.openOrdersModal.show = false" />
    <BotOrdersModal
      :show="botOrdersModalShow"
      :orders="botOrders"
      :botName="botName"
      :symbol="botSymbol"
      @on-cancel="botOrdersModalShow = false"
    />
    <Confirm
      :show="confirmCnlBotModalShow"
      :text="confirmCnlBotModalText"
      :btname="confirmCnlBotModalBtnName"
      @on-cancel="confirmCnlBotModalShow = false"
      @confirmed="cancelBot(selectedBotId)"
    />
    <Confirm
      :show="confirmPanicSellBotModalShow"
      :text="confirmCnlBotModalText"
      :btname="confirmCnlBotModalBtnName"
      @on-cancel="confirmPanicSellBotModalShow = false"
      @confirmed="panicSellBot(selectedBotId)"
    />
    <!--      <EditBot :bot="selectEditBot" @on-cancel="hideEditBot" @confirmed="hideEditBot"/>-->
    <div class="filterBox">
      <RadioGroup
        id="acthist"
        style="min-width: 179px;"
        v-model="type"
        type="button"
        size="default"
        @on-change="typeChanged"
      >
        <Radio
          label="act"
          style="font-size: 12px"
        >{{ $text.tr('АКТИВНЫЕ') }}</Radio>
        <Radio
          label="hist"
          style="font-size: 12px"
        >{{ $text.tr('ИСТОРИЯ') }}</Radio>
      </RadioGroup>
      <Button
        id="new"
        size="small"
        :disabled="$store.state.sys.tradeExchange.ExchId === 'BIF' || $store.state.sys.tradeExchange.ExchId === 'BYF' || $store.state.sys.tradeExchange.ExchId === 'BYB' || $store.state.sys.tradeExchange.ExchId === 'GET' || $store.state.sys.tradeExchange.ExchId === 'GEF'"
        long
        style="width: 130px; height: 30px;"
        @click="showNewBot"
      >
        <div>{{ $text.tr('НОВЫЙ БОТ') }}</div>
      </Button>
      <SymbolsChooser
        id="symbol"
        v-model="symbol"
        :symbols="botSymbols"
        :disabled="$store.state.bots.editMode"
        @click="selectSymbol"
        selectStyle
      />
      <i-input
        id="search"
        v-model="searchTxt"
        @on-keydown="searchCanceled($event)"
        clearable
        :placeholder="$text.tr('поиск')"
        style="width: 177px;"
      ></i-input>
      <div
        id="symbolfilter"
        style="display: flex; align-items: center"
      >
        <Checkbox
          v-model="symbolFilter"
          size="large"
        ></Checkbox>
        <div style="font-size: 11px; text-align: left">{{ $text.tr('ФИЛЬТР ПО ПАРЕ') }}</div>
      </div>
      <div
        id="statusfilter"
        v-if="type === 'act'"
        style="text-align: left;"
      >
        <Select
          v-model="statusFilter"
          class="status-filter"
          size="default"
        >
          <Option
            v-for="(status, index) in actStatuses"
            :value="status.en"
            :key="'act-' + index"
            style="font-size: 18px;"
          >{{ $text.tr(status.ru) }}</Option>
        </Select>
      </div>
      <a
        id="instruction"
        :href="$text.tr('https://doc.capico.app/v/ru/features/bot')"
        target="_blank"
        style="color: #6b74e7; font-size: 14px;"
      >{{ $text.tr('ИНСТРУКЦИЯ') }}</a>
      <div id="openorders">
        <button
          class="ghost-btn ghost-btn_small"
          :title="$text.tr('Список ордеров на бирже')"
          @click="showOpenOrdersModal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 60 60"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.5 17C4.669 17 4.83583 16.9907 5 16.9725V17H55.5H56V16.9725C58.25 16.7238 60 14.8163 60 12.5C60 10.1837 58.25 8.27619 56 8.02746V8H55.5H5V8.02746C4.83583 8.00932 4.669 8 4.5 8C2.01472 8 0 10.0147 0 12.5C0 14.9853 2.01472 17 4.5 17Z"
              class="ghost-btn__fill"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.5 34C4.669 34 4.83583 33.9907 5 33.9725V34H55.5H56V33.9725C58.25 33.7238 60 31.8163 60 29.5C60 27.1837 58.25 25.2762 56 25.0275V25H55.5H5V25.0275C4.83583 25.0093 4.669 25 4.5 25C2.01472 25 0 27.0147 0 29.5C0 31.9853 2.01472 34 4.5 34Z"
              class="ghost-btn__fill"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.5 51C4.669 51 4.83583 50.9907 5 50.9725V51H55.5H56V50.9725C58.25 50.7238 60 48.8163 60 46.5C60 44.1837 58.25 42.2762 56 42.0275V42H55.5H5V42.0275C4.83583 42.0093 4.669 42 4.5 42C2.01472 42 0 44.0147 0 46.5C0 48.9853 2.01472 51 4.5 51Z"
              class="ghost-btn__fill"
            />
          </svg>
        </button>
      </div>
    </div>
    <div style="color: var(--color-neutral-light); margin-top: 10px; margin-bottom: 10px; margin-left: 8px; font-size: 12px; display: flex; flex-wrap: wrap; justify-content: center;">
      <template v-for="symbSC in shortcuts">
        <span
          :key="'symbsc-' + symbSC"
          style="border-bottom: 1px dashed var(--color-neutral-light); cursor: pointer; margin-right: 10px; margin-top: 2px"
          @click="shortcutClicked(symbSC)"
        >{{ symbSC.replace('_','/') }}</span>
      </template>
    </div>
    <hr />
    <div class="bots-header">
      <div
        v-for="(sort1, index) in sortBy"
        :key="index + '-' + sort.field"
      >
        <span
          class="bots-header__item"
          @click="sortList(sort1.field)"
        >{{
              $text.tr(sort1.name)
            }}</span>
        <div style="display: inline-block; width: 5px">
          <Icon
            v-if="sort.field === sort1.field && sort.direction === 1"
            type="md-arrow-dropup"
          />
          <Icon
            v-if="sort.field === sort1.field && sort.direction === -1"
            type="md-arrow-dropdown"
          />
        </div>
      </div>
    </div>
    <hr />
    <table class="bots-table">
      <tr>
        <div style="
              width: 100%;
              display: flex;
              justify-content: space-around;
              flex-wrap: wrap;
            ">
        </div>
      </tr>
      <tr
        v-if="botsFiltered.length === 0"
        class="notrades"
      >
        <td colspan="8">
          <div style="padding-top: 25px;">{{ $text.tr('Нет ботов') }}</div>
        </td>
      </tr>
      <template v-for="(bot, index) in botsFiltered">
        <tr
          :key="bot.Id"
          class="tablerow"
          :class="{'oddrow': index % 2 === 0}"
        >
          <td class="bots-table-cell">
            <div style="display: flex; align-items: center;">
              <div style="height: 20px; width: 20px; margin-right: 3px">
                <CoinIcon :symbol="bot.Symbol" />
              </div>
              <span
                class="action"
                v-on:click="editBot(bot)"
                style="cursor: pointer; font-size: 18px; font-weight: normal; margin-right: 3px"
              >
                {{ returnSymbol(bot.Symbol) }}
              </span>
              <Icon
                style="cursor: pointer;"
                size="15"
                :title="$text.tr('Показать сделки')"
                type="ios-list-box-outline"
                color="var(--color-text-dark)"
                @click="getBotOrders(bot.Id, bot.Name, bot.Symbol)"
              ></Icon>
            </div>
            <div
              class="table-names"
              style="font-size: 12px"
            >{{ bot.Name }}</div>
            <div style="font-size: 12px; cursor: pointer" @click="$copyToClipboardAndNotify(bot.Id)">#{{ bot.Id }}</div>
            <div style="font-size: 12px">{{ localTime(bot.Created)[0] }} {{ localTime(bot.Created)[1] }}</div>
          </td>
          <!--            <td class="bots-table-cell">{{ localTime(bot.Created)[0] }}<br>{{ localTime(bot.Created)[1] }}</td>-->
          <!--            <td class="bots-table-cell">{{ bot.Name }}</td>-->
          <!--            <td class="bots-table-cell">{{  returnSymbol(bot.Symbol) }}</td>-->

          <td
            class="bots-table-cell"
            style="font-size: 12px; text-align: center;"
          >
            <BotProgress
              v-if="bot.Status !== 'OFF'"
              :buy="bot.BuyPrice"
              :sl="bot.StopLoss"
              :sell="bot.SellPrice"
              :last="bot.Last"
              :gray="bot.Stage === 'WAITBUY'"
              :paused="bot.Status === 'PAU'"
            />
            <table
              v-if="bot.Status === 'OFF'"
              style="width: 100%"
            >
              <tr>
                <td
                  width="50%"
                  style="text-align: left"
                >
                  <div :class="returnBotClass(bot.Status, bot.Stage)">
                    {{ $text.tr(returnBotStatus(bot.Status, bot.Stage)) }}
                  </div>
                  <div>
                    {{ localTime(bot.Updated)[0] }} {{ localTime(bot.Updated)[1] }}
                  </div>
                </td>
                <td
                  width="50%"
                  class="bot-hist-info-cell"
                >
                  <table>
                    <tr>
                      <td class="table-names table-names-top-padding">{{ $text.tr('ПОКУПКА') }}</td>
                      <td class="table-value-text">
                        {{ bot.BuyPrice }}
                      </td>
                    </tr>
                    <tr>
                      <td class="table-names table-names-top-padding">{{ $text.tr('ПРОДАЖА') }}</td>
                      <td class="table-value-text">
                        {{ bot.SellPrice }} ({{ ((parseFloat(bot.SellPrice) - parseFloat(bot.BuyPrice)) * 100 / parseFloat(bot.BuyPrice)).toFixed(1) }}%)
                      </td>
                    </tr>
                    <tr v-if="parseFloat(bot.StopLoss) !== 0">
                      <td class="table-names table-names-top-padding">STOP LOSS</td>
                      <td class="table-value-text">{{ bot.StopLoss }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>

          <!--            <td class="bots-table-cell">-->
          <!--              <table>-->

          <!--                <tr>-->
          <!--                  <td class="table-names table-names-top-padding">ПОКУПКA</td>-->
          <!--                  <td class="table-value-text">-->
          <!--                    {{ bot.BuyPrice }}-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--                <tr>-->
          <!--                  <td class="table-names table-names-top-padding">ПРОДАЖА</td>-->
          <!--                  <td class="table-value-text">-->
          <!--                    {{ bot.SellPrice }} ({{ ((parseFloat(bot.SellPrice) - parseFloat(bot.BuyPrice)) * 100 / parseFloat(bot.BuyPrice)).toFixed(1) }}%)-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--                <tr v-if="bot.Status !== 'OFF'">-->
          <!--                  <td class="table-names table-names-top-padding">СЕЙЧАС</td>-->
          <!--                  <td class="table-value-text" :class="{gwhite: bot.Stage === 'WAITBUY', ggreen: parseFloat(bot.Last) >= parseFloat(bot.BuyPrice), gred: parseFloat(bot.Last) < parseFloat(bot.BuyPrice)}">-->
          <!--                    {{ bot.Last }} ({{ ((parseFloat(bot.Last) - parseFloat(bot.BuyPrice)) * 100 / parseFloat(bot.BuyPrice)).toFixed(1) }}%)-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--              </table>-->
          <!--&lt;!&ndash;              <span class="table-names">ПОКУПКA</span> {{ bot.BuyPrice}} {{ returnQuoteAsset(bot.Symbol)}}<br>&ndash;&gt;-->
          <!--&lt;!&ndash;              <span class="table-names">ПРОДАЖА</span> {{ bot.SellPrice }} {{ returnQuoteAsset(bot.Symbol)}}&ndash;&gt;-->
          <!--            </td>-->

          <td class="bots-table-cell">
            <table>
              <tr v-if="parseFloat(bot.Trigger) !== 0">
                <td class="table-names table-names-top-padding">{{ $text.tr('ТРИГГЕР-ЦЕНА') }}</td>
                <td class="table-value-text">{{ bot.Trigger }}</td>
              </tr>
              <!--                <tr v-if="parseFloat(bot.StopLoss) !== 0">-->
              <!--                  <td class="table-names table-names-top-padding">STOP LOSS</td>-->
              <!--                  <td class="table-value-text">{{ bot.StopLoss }}</td>-->
              <!--                </tr>-->
              <tr v-if="bot.Relaunch">
                <td colspan="2">
                  <span class="table-names table-names-top-padding">{{ $text.tr('АВТО-ПЕРЕЗАПУСК') }} </span>
                  <Icon
                    type="md-checkmark"
                    size="8"
                    style="padding-left: 2px"
                  />
                </td>
              </tr>
            </table>
          </td>
          <td class="bots-table-cell">
            <div class="table-names">{{ $text.tr('ИНВЕСТИРОВАНО') }}</div>
            <div :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ bot.Amount }} {{ returnQuoteAsset(bot.Symbol) }}</div></div>
          </td>
          <td style="padding-right: 10px">
            <div
              v-if="bot.Profit"
              class="profitText"
              :class="{'gred': bot.Profit.Usd < 0, 'ggreen': bot.Profit.Usd >= 0, 'blur-balance': $store.state.sys.hideBalances}"
            >
              <div>{{  parseFloat(bot.Profit.Usd).toFixed(2) }} USD</div>
            </div>
            <div
              :class="{gred: parseFloat(returnProfitBaseText(bot)) < 0, ggreen: parseFloat(returnProfitBaseText(bot)) >= 0, 'blur-balance': $store.state.sys.hideBalances}"
              class="profitText"
              v-if="bot.Accumulate === 'B'"
            ><div>{{ returnProfitBaseText(bot) }}</div></div>
            <div
              :class="{gred: parseFloat(returnProfitQuoteText(bot)) < 0, ggreen: parseFloat(returnProfitQuoteText(bot)) >= 0, 'blur-balance': $store.state.sys.hideBalances}"
              class="profitText"
            ><div>{{ returnProfitQuoteText(bot) }}</div></div>
            <div
              :class="{gred: parseFloat(returnProfitPctText(bot)) < 0, ggreen: parseFloat(returnProfitPctText(bot)) >= 0}"
              class="profitText"
            >{{ returnProfitPctText(bot) }}</div>
          </td>
          <td>
            <Icon
              class="actionButton"
              :title="$text.tr('Скопировать бота')"
              type="md-document"
              color="var(--color-text-dark)"
              @click="showBotCopy(bot)"
            ></Icon>
          </td>
          <td>
            <Icon
              v-if="!botLoading[bot.Id] && bot.Status === 'ACT'"
              class="actionButton"
              :title="$text.tr('Остановить бота')"
              type="md-pause"
              color="var(--color-text-dark)"
              @click="pauseBot(bot.Id)"
            ></Icon>
            <Icon
              v-if="!botLoading[bot.Id] && bot.Status === 'PAU'"
              class="actionButton"
              :title="$text.tr('Включить бота')"
              type="md-play"
              color="var(--color-text-dark)"
              @click="startBot(bot.Id)"
            ></Icon>
            <!--              <pulse-loader :loading="true" color="var(--color-text-dark)" :size="'6px'"></pulse-loader><br>-->
            <!--              <scale-loader :loading="true" color="var(--color-text-dark)" :height="'10px'" :width="'2px'"></scale-loader><br>-->
            <!--              <grid-loader :loading="true" color="var(--color-text-dark)" :size="'3px'"></grid-loader><br>-->
            <!--              <beat-loader :loading="true" color="var(--color-text-dark)" :size="'6px'"></beat-loader><br>-->
            <clip-loader
              :loading="botLoading[bot.Id] === true"
              style="padding-top: 10px;"
              color="var(--color-text-dark)"
              :size="'16px'"
            ></clip-loader>
          </td>
          <td>
            <Icon
              v-if="bot.Status !== 'OFF' && bot.Stage === 'WAITSELL'"
              class="actionButton"
              :title="$text.tr('Продать и выключить бота')"
              type="logo-usd"
              color="var(--color-text-dark)"
              @click="showPanicSellBotModal(bot.Id)"
            ></Icon>
          </td>
          <td>
            <Icon
              v-if="bot.Status !== 'OFF'"
              class="actionButton"
              :title="$text.tr('Выключить бота')"
              type="md-close"
              color="var(--color-text-dark)"
              @click="showCancelBotModal(bot.Id)"
            ></Icon>
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import SymbolsChooser from '@/components/common/SymbolsChooser.vue'
import BotApi from '@/util/botapi'
import Confirm from '../../common/Confirm'
import BotOrdersModal from './BotOrdersModal'
import Bots from '@/services/bots'
import Vue from 'vue'
import BotProgress from '../../common/BotProgress'
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
// import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
// import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
// import GridLoader from 'vue-spinner/src/GridLoader.vue'
import ReconnectingWebSocket from 'reconnecting-websocket'
import Util from '@/util/util'
import OpenOrdersModal from '@/components/common/OpenOrdersModal'
import CoinIcon from '@/components/common/CoinIcon'
import common from '@/services/common'

export default {
  name: 'BotsList',
  components: {
    BotOrdersModal,
    Confirm,
    ClipLoader,
    BotProgress,
    OpenOrdersModal,
    CoinIcon,
    SymbolsChooser
    // ScaleLoader,
    // BeatLoader,
    // PulseLoader,
    // GridLoader
  },
  data () {
    return {
      statusFilter: localStorage.getItem('capico_app_bot_act_status') || 'ALL',
      actStatuses: [
        { en: 'ALL', ru: 'Все' },
        { en: 'ACT', ru: 'Активные' },
        { en: 'WAITBUY', ru: 'Ожидает покупку' },
        { en: 'WAITSELL', ru: 'Ожидает продажу' },
        { en: 'PAU', ru: 'Остановлен' }
      ],
      symbolFilter:
        localStorage.getItem('capico_app_bot_symbol_filter') === 'true',
      searchTxt: '',
      confirmPanicSellBotModalShow: false,
      getBotListInterval: null,
      selectEditBot: {},
      botSymbol: '',
      botName: '',
      botOrders: [],
      botOrdersModalShow: false,
      selectedBotId: '',
      confirmCnlBotModalBtnName: '',
      confirmCnlBotModalText: '',
      confirmCnlBotModalShow: false,
      type: 'act',
      shortcuts: [],
      symbol: '',
      botLoading: {},
      zzz: false,
      sort: {
        direction: -1,
        field: 'date'
      },
      sortBy: [
        { field: 'coin', name: 'МОНЕТА' },
        { field: 'date', name: 'ДАТА' },
        { field: 'invested', name: 'ИНВЕСТИРОВАНО' },
        { field: 'price', name: 'ЦЕНА' },
        { field: 'profitusd', name: 'ПРИБЫЛЬ $' },
        { field: 'profit', name: 'ПРИБЫЛЬ %' }
      ]
    }
  },
  computed: {
    exchId () {
      return this.$store.state.sys.tradeExchange.ExchId
    },
    botSymbols () {
      if (this.exchId === 'FTX' || this.exchId === 'OKX') {
        return this.$store.state.data.symbols.filter(symbol => {
          return !symbol.baseAsset.includes('-')
        })
      }

      return this.$store.state.data.symbols
    },
    botsFiltered () {
      let list = []

      if (this.searchTxt !== '') {
        list = this.botdata.botsList.filter(bot => {
          if (
            bot.Symbol.toLowerCase().includes(
              this.searchTxt.replace('/', '_').toLowerCase()
            )
          ) {
            return true
          }
          if (
            bot.Id.toLowerCase().includes(
              this.searchTxt.replace('#', '').toLowerCase()
            )
          ) {
            return true
          }
          return false
        })
      } else if (this.symbolFilter) {
        list = this.botdata.botsList.filter(bot => {
          if (
            bot.Symbol.toLowerCase().includes(
              this.$store.state.bots.symbol.replace('/', '_').toLowerCase()
            )
          ) {
            return true
          }
        })
      } else {
        this.botdata.botsList.forEach(item => list.push(item))
      }

      if (this.statusFilter !== 'ALL' && this.type === 'act') {
        if (this.statusFilter === 'PAU') {
          list = list.filter(bot => {
            if (bot.Status.includes(this.statusFilter)) {
              return true
            }
          })
        } else if (this.statusFilter === 'ACT') {
          list = list.filter(bot => {
            if (!bot.Status.includes('PAU')) {
              return true
            }
          })
        } else {
          list = list.filter(bot => {
            if (
              bot.Stage.includes(this.statusFilter) &&
              !bot.Status.includes('PAU')
            ) {
              return true
            }
          })
        }
      }

      list.sort((a, b) => {
        let direction = 1
        switch (this.sort.field) {
          case 'coin':
            direction = a.Symbol > b.Symbol ? 1 : -1
            break
          case 'date':
            if (this.$store.state.trades.filt.type === 'act') {
              direction =
                new Date(a.CreatedDate) > new Date(b.CreatedDate) ? 1 : -1
            } else {
              direction =
                new Date(a.ClosedDate) > new Date(b.ClosedDate) ? 1 : -1
            }
            break
          case 'dir':
            direction = a.Side > b.Side ? 1 : -1
            break
          case 'amount':
            if (parseFloat(a.AmountLeft) === parseFloat(b.AmountLeft)) {
              direction = parseFloat(a.Amount) > parseFloat(b.Amount) ? 1 : -1
            } else {
              direction =
                parseFloat(a.AmountLeft) > parseFloat(b.AmountLeft) ? 1 : -1
            }
            break
          case 'invested':
            direction = parseFloat(a.Amount) > parseFloat(b.Amount) ? 1 : -1
            break
          case 'price':
            direction = parseFloat(a.BuyPrice) > parseFloat(b.BuyPrice) ? 1 : -1
            break
          case 'profit':
            if (!a.Profit) {
              return 1
            } else if (!b.Profit) {
              return -1
            }

            if (
              parseFloat(a.Profit.Pct) === 0 &&
              parseFloat(b.Profit.Pct) === 0
            ) {
              const aPct = new Decimal(a.Last)
                .sub(a.BuyPrice)
                .div(a.BuyPrice)
                .mul(100)
                .toDecimalPlaces(2)
              const bPct = new Decimal(b.Last)
                .sub(b.BuyPrice)
                .div(b.BuyPrice)
                .mul(100)
                .toDecimalPlaces(2)
              direction = aPct.greaterThan(bPct) ? 1 : -1
            } else if (parseFloat(a.Profit.Pct) === 0) {
              direction = 1 * this.sort.direction
            } else if (parseFloat(b.Profit.Pct) === 0) {
              direction = -1 * this.sort.direction
            } else {
              direction =
                parseFloat(a.Profit.Pct) > parseFloat(b.Profit.Pct) ? 1 : -1
            }
            break
          case 'profitusd':
            if (!a.Profit) {
              return 1
            } else if (!b.Profit) {
              return -1
            }

            if (
              parseFloat(a.Profit.Usd) === 0 &&
              parseFloat(b.Profit.Usd) === 0
            ) {
              const aPct = new Decimal(a.Last)
                .sub(a.BuyPrice)
                .div(a.BuyPrice)
                .mul(100)
                .toDecimalPlaces(2)
              const bPct = new Decimal(b.Last)
                .sub(b.BuyPrice)
                .div(b.BuyPrice)
                .mul(100)
                .toDecimalPlaces(2)
              direction = aPct.greaterThan(bPct) ? 1 : -1
            } else if (parseFloat(a.Profit.Usd) === 0) {
              direction = 1 * this.sort.direction
            } else if (parseFloat(b.Profit.Usd) === 0) {
              direction = -1 * this.sort.direction
            } else {
              direction =
                parseFloat(a.Profit.Usd) > parseFloat(b.Profit.Usd) ? 1 : -1
            }
            break
        }
        return this.sort.direction * direction
      })

      return list
    },
    botdata () {
      return this.$store.state.bots
    }
  },
  watch: {
    statusFilter: function (value) {
      localStorage.setItem('capico_app_bot_act_status', value)
    },
    symbolFilter: function (filter) {
      localStorage.setItem(
        'capico_app_bot_symbol_filter',
        JSON.stringify(filter)
      )
    },
    'botdata.symbol' (newSymbol) {
      this.symbol = newSymbol.replace('_', '/')
      // this.getActiveBotList()
    },
    $route (to, from) {
      // console.log('route:', to)
      if (to.name === 'bots') {
        this.getBotList()
        this.createIntervals()
        Bots.UpdateBotBalance()
      }
      if (from.name === 'bots') {
        this.clearIntervals()
      }
    },
    '$store.state.sys.tradeExchange.Id': function () {
      // console.log('bot list tradeExchange changed')
      this.botdata.editBot = {}
      this.botdata.editMode = false
      this.getBotList()
    },
    '$store.state.bots.botsUpdated': function () {
      this.getBotList()
    }
  },
  methods: {
    sortList (field) {
      this.sort.field = field
      this.sort.direction = -1 * this.sort.direction
    },
    showOpenOrdersModal () {
      common.getOpenOrders()
    },
    pauseBot (botID) {
      const ref = this
      Vue.set(this.botLoading, botID, true)
      BotApi.get('bot/pause', {
        params: {
          token: this.$store.state.sys.token,
          id: botID
        }
      })
        .then(function (response) {
          // console.log(response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              ref.getBotList().then(() => {
                ref.botLoading[botID] = false
              })
              Bots.UpdateBotBalance()
            } else {
              // error
              ref.botLoading[botID] = false
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          }
        })
        .catch(function (error) {
          // error
          ref.botLoading[botID] = false
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    selectSymbol (symbol) {
      Bots.SelectBotSymbol(symbol.replace('/', '_'))
      Bots.UpdateBotBalance()
    },
    shortcutClicked (symbol1) {
      // console.log('shortcutClicked', symbol1)
      this.botdata.editMode = false
      // this.searchTxt = symbol.replace('_', '/')
      this.symbol = symbol1
      Bots.SelectBotSymbol(symbol1)
      Bots.UpdateBotBalance()
    },
    searchCanceled (e) {
      if (e.keyCode === 27) {
        this.searchTxt = ''
      }
    },
    typeChanged () {
      // this.botdata.botsList = []
      this.getBotList()
    },
    showPanicSellBotModal (botID) {
      this.selectedBotId = botID
      this.confirmCnlBotModalBtnName = this.$text.tr('ДА')
      this.confirmCnlBotModalText = this.$text.tr(
        'Выключить бота и продать по рынку?'
      )
      this.confirmPanicSellBotModalShow = true
    },
    panicSellBot (botID) {
      this.confirmPanicSellBotModalShow = false
      const ref = this
      BotApi.get('bot/panic', {
        params: {
          token: this.$store.state.sys.token,
          etid: this.$store.state.sys.tradeExchange.Id,
          id: botID
        }
      })
        .then(function (response) {
          // console.log(response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              ref.getBotList()
              Bots.UpdateBotBalance()

              ref.$Message.success({
                content: ref.$text.tr('Выполнено'),
                duration: 1
              })
            } else {
              // error
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          }
        })
        .catch(function (error) {
          // error
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    returnProfitPctText (bot) {
      if (bot.Profit !== null) {
        return bot.Profit.Pct + '%'
      }
      return ''
    },
    returnProfitQuoteText (bot) {
      if (bot.Profit !== null) {
        // if (bot.Accumulate === 'B') {
        //   return bot.Profit.Base + ' ' + bot.Symbol.split('_')[0]
        // }
        return bot.Profit.Quote + ' ' + this.returnQuoteAsset(bot.Symbol)
      }
      return ''
    },
    returnProfitBaseText (bot) {
      if (bot.Profit !== null) {
        return bot.Profit.Base + ' ' + bot.Symbol.split('_')[0]
      }
      return ''
    },
    startBot (botID) {
      const ref = this
      Vue.set(this.botLoading, botID, true)
      BotApi.get('bot/start', {
        params: {
          token: this.$store.state.sys.token,
          etid: this.$store.state.sys.tradeExchange.Id,
          id: botID
        }
      })
        .then(function (response) {
          // console.log(response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              ref.getBotList().then(() => {
                ref.botLoading[botID] = false
              })
              Bots.UpdateBotBalance()
            } else {
              // error
              ref.botLoading[botID] = false
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          }
        })
        .catch(function (error) {
          // error
          console.log(error)
          ref.botLoading[botID] = false
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    createIntervals () {
      this.getBotListInterval = setInterval(this.getBotList, 60000)
      // console.log('getBotList interval created')
    },
    clearIntervals () {
      clearInterval(this.getBotListInterval)
      // console.log('getBotList interval cleared')
    },
    editBot (bot) {
      Bots.SelectBotSymbol(bot.Symbol)
      this.$store.state.bots.editMode = true
      this.$store.state.bots.editBot = bot
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    getBotOrders (botID, botName, botSymbol) {
      const ref = this
      BotApi.get('bot/orders', {
        params: {
          token: this.$store.state.sys.token,
          id: botID
        }
      })
        .then(function (response) {
          // console.log(response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              ref.botOrders = response.data
              ref.botName = botName
              ref.botSymbol = botSymbol
              ref.botOrdersModalShow = true
            } else {
              // error
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          } else {
            ref.$Notice.info({
              title: ref.$text.tr('нет ордеров'),
              duration: 1
            })
          }
        })
        .catch(function (error) {
          // error
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    cancelBot (botID) {
      this.confirmCnlBotModalShow = false
      const ref = this
      BotApi.get('bot/stop', {
        params: {
          token: this.$store.state.sys.token,
          id: botID
        }
      })
        .then(function (response) {
          // console.log(response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              ref.getBotList()
              Bots.UpdateBotBalance()

              ref.$Message.success({
                content: ref.$text.tr('Бот выключен'),
                duration: 1
              })
            } else {
              // error
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          }
        })
        .catch(function (error) {
          // error
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    showCancelBotModal (botID) {
      this.selectedBotId = botID
      this.confirmCnlBotModalBtnName = this.$text.tr('ДА')
      this.confirmCnlBotModalText = this.$text.tr(
        'Выключить бота и отменить все выставленные ордера?'
      )
      this.confirmCnlBotModalShow = true
    },
    returnBotClass (status, stage) {
      if (status === 'ACT') {
        return ''
      } else if (status === 'OFF') {
        return ''
      } else {
        return 'yellow'
      }
    },
    returnBotStatus (status, stage) {
      if (status === 'ACT') {
        if (stage === 'WAITBUY') {
          return 'Ожидает покупку'
        } else if (stage === 'WAITSELL') {
          return 'Ожидает продажу'
        }
      } else if (status === 'OFF') {
        if (stage === 'SLSELL') {
          return 'Выключен по SL'
        } else if (stage === 'PANICSELL') {
          return 'Продано вручную'
        }
        return 'Выключен'
      } else {
        return 'Остановлен'
      }
    },
    showNewBot () {
      this.$store.state.bots.editMode = true
      this.$store.state.bots.editBot = {}
    },
    showBotCopy (bot) {
      Bots.SelectBotSymbol(bot.Symbol)
      const botCopy = JSON.parse(JSON.stringify(bot))
      botCopy.Id = ''
      delete botCopy.Created
      delete botCopy.CycleStarted
      delete botCopy.Updated
      delete botCopy.Stage
      delete botCopy.Profit
      botCopy.Status = 'COPY'

      this.$store.state.bots.editMode = true
      this.$store.state.bots.editBot = botCopy
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    returnQuoteAsset (symbol) {
      const assets = symbol.split('_')
      return assets[1]
    },
    returnSymbol (symbol) {
      const assets = symbol.split('_')
      return assets[0] + '/' + assets[1]
    },
    localTime (utctime) {
      return new Date(utctime)
        .toLocaleString('ru-RU')
        .replace(',', '')
        .split(' ')
    },
    getBotList () {
      if (this.$router.currentRoute.name !== 'bots') {
        return
      }
      Bots.GetActiveBotList()
      const ref = this
      return BotApi.get('bot/list', {
        params: {
          token: this.$store.state.sys.token,
          etid: this.$store.state.sys.tradeExchange.Id,
          status: this.type
        }
      })
        .then(function (response) {
          // console.log(JSON.stringify(response.data))
          ref.botdata.botsList = []
          ref.shortcuts = []
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              if (response.data) {
                ref.botdata.botsList = response.data
                const newSC = []
                response.data.forEach(bot => {
                  newSC.push(bot.Symbol)
                })
                let unique = newSC.filter((v, i, a) => a.indexOf(v) === i)
                unique = unique.sort(function (a, b) {
                  return ('' + a).localeCompare(b)
                })
                ref.shortcuts = unique
                // console.log('shortcuts', ref.shortcuts)
              }
            } else {
              // error
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          }
        })
        .catch(function (error) {
          // error
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    initWs () {
      const ws = new ReconnectingWebSocket(
        'wss://titan.capico.app:2525/ws?token=' + this.$store.state.sys.token
      )
      ws.onopen = () => {
        // console.log('capico ws connected')
        // let msg1 = '{"method":"subscribe","params":{"channel":"BTC_USD_15"},"uid":"1"}'
        ws.send('ping')
      }

      ws.onerror = error => {
        console.log('capico ws error:', error)
      }

      ws.onclose = () => {
        // console.log('capico ws closed')
      }

      ws.onmessage = e => {
        // console.log('capico ws msg:', e.data)
        this.getBotList()
      }
    }
  },
  created () {
    this.symbol = this.$store.state.bots.symbol.replace('_', '/')
    this.getBotList()
    this.createIntervals()
    Bots.UpdateBotBalance()
    // this.initWs()
  },
  destroyed () {
    this.clearIntervals()
  }
}
</script>
